import EditSprintLengthFormDto from 'types/PrpTable/dto/EditSprintLengthFormDto';

const EditSprintLengthDefaultValue: EditSprintLengthFormDto = {
  sprintId: null,
  amount: 2,
  note: ''
};

export default EditSprintLengthDefaultValue;
